export default __webpack_public_path__ + "static/media/landing4.4da1de5b.jpeg";